import type { MessageSchema } from "./zh";

const messages: MessageSchema = {
  common: {
    appName: "餃子雲",
    appNameGlobal: "Starparks",
    confirm: "確定",
    cancel: "取消",
    loginRegister: "登入 / 註冊",
    userAgreement: "服務條款",
    privacyPolicy: "隱私權政策",
    notBound: "尚未設定",
  },
  tabbar: {
    home: "首頁",
    search: "搜尋",
    library: "遊戲庫",
    mine: "我的",
    badgeLogin: "登入",
    badgeUpgrade: "升級",
  },
  login: {
    navTitle: "登入",
    welcome: "歡迎使用{brand}",
    subtitle: "用手機驗證碼登入，或透過微信 / QQ 快速登入",
    subtitleGlobal: "免註冊立即試玩，或用 Google / Telegram / Facebook 登入",
    mobileLabel: "手機號碼",
    mobilePlaceholder: "請輸入手機號碼",
    codeLabel: "驗證碼",
    codePlaceholder: "簡訊驗證碼",
    getCode: "取得驗證碼",
    resendIn: "{sec} 秒後重新發送",
    agreement:
      "尚未註冊的號碼通過驗證後會自動建立帳號，繼續即表示同意 {userAgreement} 與 {privacyPolicy}",
    otherMethods: "其他登入方式",
    guest: "以訪客身分繼續",
    wechat: "用微信登入",
    qq: "用 QQ 登入",
    google: "使用 Google 繼續",
    telegram: "\u4f7f\u7528 Telegram \u7e7c\u7e8c",
    facebook: "使用 Facebook 繼續",
    wechatComingSoon: "微信登入即將推出",
    qqComingSoon: "QQ 登入即將推出",
    googleComingSoon: "Google 登入即將推出",
    googleFailed: "Google 登入失敗，請再試一次",
    telegramFailed: "Telegram \u767b\u5165\u5931\u6557\uff0c\u8acb\u518d\u8a66\u4e00\u6b21",
    facebookComingSoon: "Facebook 登入即將推出",
    mobileInvalid: "請輸入正確的手機號碼",
    codeInvalid: "請輸入驗證碼",
    codeSent: "驗證碼已發送",
  },
  loginPrompt: {
    defaultMessage: "登入後即可查看你的遊戲",
  },
  settings: {
    navTitle: "設定",
    loginPrompt: "登入後即可管理帳號設定",
    nickname: "暱稱",
    mobile: "手機號碼",
    controller: "操控設定",
    controllerDesc: "滑鼠靈敏度 / 右搖桿 / 按鍵互換",
    about: "關於",
    clearCache: "清除本機快取",
    language: "語言",
    editNickname: "修改暱稱",
    nicknamePlaceholder: "新暱稱",
    nickEmpty: "暱稱不能空白",
    nickTooLong: "暱稱最多 16 個字",
    updated: "已更新",
    cacheCleared: "已清除，請重新登入",
    aboutTitle: "關於{brand}",
    aboutVersion: "網頁版 v{version}",
    aboutBody:
      "雲端遊戲服務，讓你隨時隨地在瀏覽器裡暢玩 3A 大作。\n所有遊戲內容版權皆歸原廠商所有。",
  },
  subscription: {
    choosePlan: "選擇方案",
    included: "包含權益",
    orderSummary: "訂單摘要",
    total: "合計",
    continue: "繼續",
    secureNote: "安全支付 · 一次性購買",
    navTitle: "升級會員",
    unlockTitle: "解鎖會員特權",
    expired: "已過期",
    daysLeft: "剩 {days} 天",
    validUntil: "有效期限至 {time}",
    tagline: "免排隊、時間更長、畫質更高",
    perDay: "每天約 {price}",
    recommended: "最超值",
    currentLevel: "目前方案",
    footer:
      "本商品為一次性會員購買。付款確認後增加所選會員天數，不會自動續費。",
    planVipMonth: "VIP 月卡",
    planSvipMonth: "SVIP 月卡",
    perkNoQueue: "免排隊進入",
    perkDailyFree: "每日免費暢玩 60 分鐘",
    perkHd: "高畫質",
    perkAllVip: "VIP 全部特權",
    perkUnlimited: "遊玩時間無上限",
    perk4k: "4K 畫質 / 60fps",
    perkSupport: "客服優先處理",
    cnPayComingSoon:
      "網頁版微信 / 支付寶付款即將推出，請先使用 App 完成購買",
    intlPayComingSoon: "Stripe / PayPal 網頁付款即將推出",
    payProcessing: "請完成付款並保持本頁開啟…",
    paySuccess: "付款成功，會員已開通",
    payFailed: "付款失敗，請稍後再試",
    payCancelled: "已取消付款",
    telegramExtraTimeUnavailable: "Telegram 內的遊戲時長購買將在接入 Stars 版本後開放。",
    payUnconfirmed: "尚未偵測到付款完成；若你已付款，款項稍後會自動入帳",
    payPopupBlocked: "付款視窗被瀏覽器擋住了，請允許彈出式視窗後再試一次",
    loadPlansFailed: "方案載入失敗，請重試",
    retry: "重試",
  },
  app: {
    backToDesktop: "切回電腦版",
  },
  titles: {
    home: "首頁",
    search: "搜尋",
    detail: "遊戲詳情",
    library: "遊戲庫",
    category: "分類",
    mine: "我的",
    myGames: "我的遊戲",
    reviews: "玩家評價",
    gameVideos: "實況影片",
    commentReplies: "留言",
    saves: "遊戲存檔",
    subscription: "升級會員",
    signIn: "每日簽到",
    settings: "設定",
    controlSettings: "操控設定",
    login: "登入",
    play: "遊戲中",
  },
  home: {
    searchPlaceholder: "搜尋遊戲",
    sectionDefault: "遊戲",
    allGames: "全部遊戲",
    more: "更多",
    empty: "這裡還沒有內容",
    latestOnline: "最新上架",
    comingSoon: "敬請期待",
    subscribe: "預約",
    subscribed: "已預約",
    score: "評分",
    subscribeSuccess: "預約成功，上架後通知你",
  },
  nav: {
    home: "首頁",
    library: "遊戲庫",
    searchPlaceholder: "搜尋遊戲",
    me: "我",
    guest: "訪客",
    profile: "個人資料",
    myGames: "我的遊戲",
    dailyCheckIn: "每日簽到",
    renewMembership: "續訂會員",
    upgradeMembership: "升級會員",
    settings: "設定",
    switchToMobile: "切換到手機版",
    logout: "登出",
    logoutConfirm: "確定要登出嗎？",
    mobileVersion: "手機版",
    login: "登入",
  },
  library: {
    all: "全部",
    noMore: "沒有更多了",
    loading: "載入中…",
    noData: "尚無資料",
    noGames: "尚無遊戲",
    noUpcoming: "目前沒有即將上架的遊戲",
    emptyCategory: "這個分類目前沒有遊戲",
  },
  mine: {
    notLoggedIn: "尚未登入",
    loginSyncTip: "登入後即可同步會員、收藏與遊戲記錄",
    loginSyncTipDesktop: "登入後即可查看個人資料、會員、簽到與遊戲記錄",
    guest: "訪客",
    daysLeft: "剩 {n} 天",
    expired: "已過期",
    renewBanner: "你的 {level} 還有 {n} 天到期，現在續訂享 7 折",
    membershipExpiredRenew: "你的會員已過期，立即續訂",
    membershipExpired: "會員已過期",
    membershipDaysLeft: "會員還剩 {n} 天",
    gameTime: "遊玩時間",
    minUnit: "分",
    dailyCheckIn: "每日簽到",
    upgrade: "升級",
    renew: "續訂",
    upgradeMembership: "升級會員",
    renewMembership: "續訂會員",
    membership: "會員",
    myCollection: "我的收藏",
    collectedGames: "收藏的遊戲",
    recentlyPlayed: "最近玩過",
    gameHistory: "遊戲記錄",
    settings: "設定",
    switchToDesktop: "切換到電腦版",
    accountAndPrefs: "帳號與偏好",
    claimGameTime: "賺取遊玩時間",
    bindPhone: "綁定手機號碼",
    bindPhoneDesc: "升級為正式帳號，跨裝置同步",
    bindPhoneDescDesktop: "升級正式帳號，跨裝置同步",
    resetGuest: "重設訪客身分",
    resetGuestDesc: "清除目前的訪客帳號，以新身分重新開始",
    resetGuestDescDesktop: "以新身分重新開始",
    logout: "登出",
    myGamesTitle: "我的遊戲",
    collectTab: "收藏",
    loginViewCollect: "登入後即可查看你收藏的遊戲",
    noCollect: "還沒有收藏任何遊戲",
    loginViewHistory: "登入後即可查看遊戲記錄",
    noHistory: "最近還沒玩過任何遊戲",
    weekMon: "週一",
    weekTue: "週二",
    weekWed: "週三",
    weekThu: "週四",
    weekFri: "週五",
    weekSat: "週六",
    weekSun: "週日",
    alreadySignedToday: "今天已經簽到了",
    signSuccessReward: "簽到成功！+{n} 分鐘",
    signSuccess: "簽到成功",
    loginJoinCheckIn: "登入後即可參加每日簽到",
    claimed: "已領取",
    unclaimed: "未領取",
    todayDone: "今日 ✓",
    today: "今日",
    dayN: "第 {n} 天",
    signedToday: "今日已簽到",
    signNow: "立即簽到",
    checkInTip1: "每日簽到即可領取免費遊玩時間。",
    checkInTip2: "漏簽的天數可在補簽頁面用金幣補回。",
    loggedOut: "已登出",
    resetGuestConfirm:
      "將清除目前的訪客帳號並以新身分重新進入，已購買的訂閱、收藏、紀錄都會遺失。確定繼續？",
    resetGuestConfirmBtn: "確認重置",
    resetting: "重置中…",
    resetDone: "已重置，請重新登入",
  },
  reviews: {
    recommendRate: "好評率",
    tooFew: "評價人數較少",
    count: "{n} 則評價",
    playFirst: "玩過遊戲才能發表評價",
    rateThis: "玩過這款遊戲，給個評價吧",
    mine: "我的",
    edit: "編輯",
    delete: "刪除",
    report: "檢舉",
    played: "玩了 {d}",
    contentEmpty: "評價內容不能為空",
    editReview: "編輯評價",
    editDone: "已更新",
    published: "評價已發布",
    deleteTitle: "刪除評價？",
    deleteConfirm: "刪除後無法復原，確認刪除這則評價？",
    deleted: "已刪除",
    reportTitle: "檢舉",
    reportConfirm: "確認檢舉這則內容？審核團隊會處理。",
    reported: "已檢舉",
    deleteReplyTitle: "刪除回覆？",
    deleteReplyConfirm: "確認刪除這則回覆？",
    replyTo: "回覆",
    viewAllReplies: "查看全部 {n} 則回覆",
    loadMore: "載入更多",
    allReplies: "全部回覆（{n}）",
    commentDeleted: "該評價已刪除",
    commentShielded: "該評價已被屏蔽",
    replyDeleted: "該回覆已刪除",
    replyShielded: "該回覆已被屏蔽",
  },
  detail: {
    svipRequiredMsg: "此遊戲需要 SVIP 資格才能遊玩",
    timeInsufficientMsg: "目前遊戲時長不足，請優先購買遊戲時長",
    goBuy: "去購買",
    thinkAgain: "再想想",
    navTitle: "遊戲詳情",
    back: "返回",
    svipOnly: "SVIP 專屬",
    vipOnly: "VIP 專屬",
    freeMinutes: "免費 {n} 分鐘",
    saveManage: "存檔管理",
    saveManageDesc: "查看 / 還原歷史存檔，並可加上備註",
    liveVideos: "實況影片",
    more: "更多",
    viewAll: "查看全部",
    viewAllCount: "查看全部 {n}",
    intro: "遊戲簡介",
    screenshots: "遊戲截圖",
    controlMethod: "操作方式：",
    playerReviews: "玩家評價",
    commentCount: "{n} 則",
    recommend: "推薦",
    notRecommend: "不推薦",
    similarGames: "相似遊戲",
    collect: "收藏",
    collected: "已收藏",
    collectStar: "☆ 收藏",
    collectedStar: "★ 已收藏",
    unfavorited: "已取消收藏",
    entering: "進入中…",
    unlockSvip: "開通 SVIP 解鎖",
    unlockVip: "開通 VIP 解鎖",
    startGame: "開始遊戲",
    reviewCount: "{n} 則評價",
    sortHot: "熱門",
    sortNew: "最新",
    noMore: "沒有更多了",
    playedHours: "玩了 {n} 小時",
    report: "檢舉",
    reportTitle: "要檢舉這則留言嗎？",
    reportMessage: "審核團隊會進行查看，確定檢舉？",
    reported: "已檢舉",
    noReviews: "還沒有評價，留下第一則吧",
    writeReview: "撰寫評價",
    reviewPlaceholder: "分享你的遊戲體驗……（至少 5 個字）",
    reviewMinLength: "評價內容至少要 5 個字",
    reviewSubmitted: "評價已送出",
    publish: "發布",
    commentDetail: "留言詳情",
    replyCount: "{n} 則回覆",
    noReplies: "還沒有回覆，搶頭香吧",
    reply: "回覆",
    replyToUser: "回覆 {'@'}{name}",
    saySomething: "說點什麼…",
    send: "送出",
    sent: "已送出",
    videoCount: "共 {n} 部影片",
    watchCount: "{wan}萬次觀看",
    noVideos: "尚無影片",
    videoUnavailable: "這部影片目前無法播放",
    videoUnavailableDesc: "可能是早期影片已下架，換一部試試看",
  },
  search: {
    placeholder: "輸入遊戲名稱",
    emptyHint: "可輸入遊戲名稱或關鍵字搜尋",
    history: "搜尋紀錄",
    clear: "清除",
    noResults: "找不到相關遊戲",
  },
  misc: {
    savesTitle: "遊戲存檔",
    savesTitleNamed: "{name} - 存檔",
    savesLoginPrompt: "登入後即可查看你的遊戲存檔",
    savesActiveHeading: "目前使用的存檔",
    savesUnnamed: "未命名存檔",
    savesEditRemark: "改備註",
    savesEmpty: "還沒有雲端存檔",
    savesEmptyHint: "在遊戲中存檔後會自動同步到這裡",
    savesHistory: "歷史存檔",
    savesCount: "{n} 則",
    savesCurrent: "目前",
    savesCorrupted: "已損壞",
    savesRestore: "還原",
    savesNoHistory: "沒有歷史存檔",
    savesFooter:
      "存檔由遊戲中的手動 / 自動存檔觸發，並會自動同步到雲端。目前不支援手動刪除存檔（在遊戲中繼續存檔，會自動覆蓋最舊的一筆）。",
    savesRemarkTitle: "修改存檔備註",
    savesRemarkPlaceholder: "幫這個存檔取個名字，例如「打完第一章」",
    savesSave: "儲存",
    savesAlreadyCurrent: "這就是目前使用的存檔",
    savesRestoreTitle: "還原存檔",
    savesRestoreConfirm:
      "要還原到這則存檔嗎？下次進入遊戲時會從「{name}」開始。",
    savesSwitched: "已切換為目前使用的存檔",
    savesSaved: "已儲存",
    ctrlNavTitle: "操控設定",
    ctrlSave: "儲存",
    ctrlIntro:
      "在這裡調整滑鼠 / 手把手感。數值留空或填 0，表示沿用各遊戲的伺服器預設設定；調整後會套用到所有遊戲。",
    ctrlMouseSensitivity: "滑鼠靈敏度",
    ctrlServerDefault: "伺服器預設",
    ctrlMouseHint: "鎖定模式下，移動距離 = 實際移動 × {n}%",
    ctrlStickSensitivity: "右搖桿靈敏度",
    ctrlStickHint:
      "FPS / 動作遊戲的瞄準轉動速度。左搖桿（移動）不受影響。",
    ctrlPrimaryClick: "滑鼠主要按鍵",
    ctrlLeftPrimary: "左鍵為主",
    ctrlRightPrimary: "右鍵為主",
    ctrlPrimaryClickHint:
      "少數遊戲（例如部分獨立遊戲）預設用右鍵開火，需要互換。",
    ctrlResetDefault: "還原預設",
    ctrlSavedToast: "已儲存，下次進入遊戲時生效",
    ctrlResetToast: "已還原為伺服器設定",
    savesUploading: "存檔上傳中，請稍後再試",
    savesCheckFailed: "取得存檔狀態失敗，請重試",
  },
  play: {
    stageReady: "準備就緒",
    queueing: "排隊中",
    queueJoining: "正在加入排隊…",
    queueAheadPrefix: "",
    queueAheadSuffix: "位玩家在你前面",
    queueEta: "約 {n} 秒",
    cancelReturn: "取消並返回",
    back: "返回",
    retry: "重試",
    goSubscribe: "去開通",
    entering: "正在進入遊戲",
    vipCta: "開通 VIP 立即進入",
    vipPerks: "免排隊 + 高畫質 + 時間更長",
    sessionExpiredHint:
      "連線通常是排隊太久才會逾時，點「重試」即可重新排隊",
    lineOldUser: "老玩家佇列",
    lineNewbie: "新手佇列",
    lineFast: "加速佇列",
    lineSvip: "SVIP 專屬佇列",
    svipRequired: "本遊戲為 SVIP 專屬，請先開通 SVIP",
    stageConnectingServer: "正在連線伺服器…",
    stageHandshake: "正在與伺服器交握…",
    stageP2pNegotiating: "正在建立 P2P 連線…",
    stageMediaStreaming: "正在串流傳輸…",
    stageWaitingFrame: "正在等待畫面…",
    stageVideoTrack: "已接收視訊軌…",
    stageEntered: "已連線",
    stageConnect: "連線",
    stageConnectedSoon: "已連線，畫面馬上就出現…",
    allocFailed: "無法配置遊戲伺服器",
    allocFailedHttp: "配置失敗（HTTP {status}）",
    reenterHint: "（請退出後重新進入遊戲）",
    errP2pFailed: "P2P 連線協商失敗，請檢查網路",
    errDisconnected: "連線中斷（code={code}），請重試",
    errStageFailed: "{stage} 失敗",
    errStageFailedDetail: "{stage} 失敗：{detail}",
    errConnectTimeout:
      "連線逾時，無法接通伺服器。請檢查網路後重試",
    errQueueCancelled: "伺服器已取消你的排隊，請重試",
    errKicked:
      "你的帳號已在其他裝置登入，因此這條連線已中斷",
    errCannotStart: "目前無法開始遊戲",
    registerFailed: "註冊失敗",
  },
  game: {
    recharge: "儲值",
    tabControl: "操控",
    tabFrame: "畫面",
    tabVoice: "聲音",
    controlScheme: "操控方式",
    hideVirtualKeys: "隱藏虛擬按鍵",
    mouseMode: "滑鼠模式",
    mouseModeTouchpad: "觸控板",
    mouseModeDrag: "拖曳",
    mouseModeDirect: "直接",
    mouseSensitivity: "滑鼠靈敏度 {n}%",
    rightStickMode: "右搖桿模式",
    joyModeFixed: "固定",
    joyModeHalf: "半螢幕",
    joyModeFull: "全螢幕",
    joyModeDrag: "拖曳",
    stickSensitivity: "搖桿靈敏度 {n}%",
    customLayout: "自訂按鍵配置",
    editLayout: "編輯配置",
    frameComingSoon:
      "畫面縮放 / 畫質切換將於後續版本推出。",
    gameSound: "遊戲聲音",
    schemeFollow: "跟隨遊戲",
    schemeGamepad: "手把",
    schemeKeyMouse: "鍵鼠",
    schemeTouch: "觸控",
    schemeSwitchedGamepad: "已切換為手把",
    schemeSwitchedKeyMouse: "已切換為鍵鼠",
    schemeSwitchedFollow: "已還原為跟隨遊戲",
    modifierTitle: "修改器",
    modifierNeedUnlock: "這個修改器需購買才能解鎖",
    usageTitle: "使用說明",
    usageEmpty: "尚無使用說明",
    gotIt: "我知道了",
    close: "關閉",
    noModifiers: "尚無修改器",
    locked: "未解鎖",
    needUnlock: "購買以解鎖",
    remaining: "剩餘 {d}",
    use: "使用",
    quitTitle: "退出遊戲",
    quitConfirm: "確定要退出目前的遊戲嗎？",
    quitConfirmBtn: "退出",
    quitCancelBtn: "繼續遊戲",
    joyNameFixed: "固定",
    joyNameHalfZone: "半螢幕熱區",
    joyNameFullFollow: "全螢幕跟隨",
    joyNameDrag: "拖曳",
    padConnected: "🎮 已連接手把，已隱藏虛擬按鍵",
    padDisconnected: "手把已中斷，已恢復虛擬按鍵",
    rightStickToast: "右搖桿：{name}",
    noEditableLayout: "沒有可編輯的按鍵配置",
    timeUsedUp: "遊玩時間已用完",
    addTimeSuccess: "加時成功",
    submitted: "已送出",
    minutesShort: "{n} 分",
    addTime: "加時",
    expand: "展開",
    collapse: "收合",
    physicalPadConnected: "已連接實體手把",
    unmute: "取消靜音",
    mute: "靜音",
    fullscreen: "全螢幕",
    summonKeyboard: "顯示鍵盤",
    sensoryMode: "遊戲體感",
    idleWarnTip: "偵測到長時間未操作，{n} 秒後將自動退出遊戲",
    idleContinue: "繼續遊戲",
    nsInputTitle: "遊戲需要輸入",
    nsInputHint: "請輸入內容後點確認",
    settings: "設定",
    currentRemaining: "目前剩餘 {n} 分鐘",
    exchangeBeans: "用彩豆兌換時間",
    useAddTimeCard: "使用加時卡",
  },
  net: {
    requestFailed: "請求失敗",
    errorWithCode: "錯誤 {code}",
    serverError: "網路錯誤 {status}",
    timeout: "請求逾時",
    networkError: "網路異常",
  },
  controls: {
    selectKeyFirst: "請先選擇一個按鍵",
    saved: "已儲存",
    saveFailed: "儲存失敗",
    selected: "已選取：{name}",
    keyFallback: "按鍵",
    hint: "拖曳即可移動位置，點選後可調整大小 / 透明度 / 動作",
    size: "大小 {pct}%",
    opacity: "透明度 {pct}%",
    operation: "動作",
    opPress: "按下",
    opDrag: "拖曳",
    opLock: "鎖定",
    delete: "刪除",
    addKey: "新增按鍵",
    reset: "重設",
    save: "儲存",
    addHiddenKey: "新增隱藏的按鍵",
    noHiddenKeys: "沒有隱藏的按鍵",
  },
};

export default messages;
